import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as Spanner } from "assets/svg/spanner.svg";
import T from "i18n";
import Base from "./Base";

const MoreHelp = ({ className }) => {
  const classes = ["MoreHelp"];
  if (className) classes.push(className);

  return (
    <Base
      className={className}
      Svg={Spanner}
      label={T({ path: "button.moreHelp" })}
    />
  );
};

MoreHelp.displayName = "MoreHelp";

MoreHelp.propTypes = {
  className: PropTypes.string,
};

MoreHelp.defaultProps = {
  className: null,
};

export default MoreHelp;
